import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { Schema } from '../../forms/GeneralPageForm'
import { toDTO } from './api/mapper'
import { UPSERT_WORKSPACE_AMAZON } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpsertWorkspaceAmazon } from './types'

export const useUpsertWorkspaceAmazon = (): UseUpsertWorkspaceAmazon => {
  const { t } = useTranslation('features/globalSetup/amazon', { keyPrefix: 'pages.general.upsert' })
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPSERT_WORKSPACE_AMAZON,
    onCompleted: async ({ upsertWorkspaceAmazon: { errors } }: Data): Promise<void> => {
      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))

        enqueueSnackbar(t('error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getWorkspaceAmazon'],
  })

  const upsert = (data: Schema): void =>
    void mutateAsync({
      input: toDTO(data),
    })

  return {
    errors,
    loading: isPending,
    upsert,
  }
}
